import React, { useEffect, useState } from "react";
import { Modal } from "rsuite";
import { MdAssignment, MdDownload } from "react-icons/md";

import api from "../../../../services/axios";
// import { upperCaseFirstLetter } from "../../../../utils/formatStringUtils";

// type ClientModel = {
//   nmCorporate: string;
//   document: string;
//   nmClient: string;
//   dtContract: Date;
//   contractTypeId: string;
//   flActive: boolean;
// };

const MONTH_LABELS = [
  "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
];

const fieldCls =
  "w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800 transition-all focus:border-dv-blue-500 focus:outline-none focus:ring-2 focus:ring-dv-blue-500/20 disabled:cursor-not-allowed disabled:opacity-60 dark:border-white/10 dark:bg-navy-900 dark:text-white";

const labelCls =
  "text-sm font-semibold text-gray-700 dark:text-gray-300";

const EntryHourReportModal: React.FC<any> = ({
  openEntryHourReportModal,
  setOpenEntryHourReportModal,
  details,
  updateState,
}) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const [projectData, setProjectData] = useState<any>([]);
  // const [employeeData, setEmployeeData] = useState<any>([]);

  const [selectedP, setSelectedP] = useState<number>(0);
  // const [selectedE, setSelectedE] = useState<number>(0);
  const [selectedC, setSelectedC] = useState<number>(0);

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;
  const [selectedYear, setSelectedYear] = useState<number>(currentYear);
  const [selectedMonth, setSelectedMonth] = useState<number>(currentMonth);

  useEffect(() => {
    // chamar api para preencher o combobox de Client e projeto
    setLoading(true)
    api
      .get("/ClientProject/list")
      .then((response) => {
        // Filtros só mostram clientes/projetos ativos.
        const active = Array.isArray(response.data)
          ? response.data.filter((cp: any) => cp.flActive)
          : [];
        setProjectData(active);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setErrorMessage(error)
      })
      .finally(() => {
        setLoading(false)
      })
    // chamar api para preencher o combobox de Employee
    // api
    //   .get("/Employee/employees")
    //   .then((response) => {
    //     setEmployeeData(response.data);
    //   })
    //   .catch((error) => {
    //     console.error("There was an error!", error);
    //   });
  }, []);

  const handleClose = () => {
    setOpenEntryHourReportModal(false);
  };

  const handleGenerateReport = async () => {
    api
      .get(
        `TimeManagement/GetReportWorkedHours?month=${selectedMonth}&year=${selectedYear}&clientId=${selectedC}&projectId=${
          selectedP === 0 ? "" : selectedP
        }`
      )
      .then((response) => {
        // setProjectData(response.data);
        console.log(response);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });

    handleClose();
  };

  const handleClientChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    console.log(event.target.value);
    setSelectedC(parseInt(event.target.value));
  };
  // const handleEmployeeChange = (
  //   event: React.ChangeEvent<HTMLSelectElement>
  // ) => {
  //   // console.log(event.target.value);
  //   setSelectedE(parseInt(event.target.value));
  // };
  const handleProjectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    // console.log(event.target.value);
    setSelectedP(parseInt(event.target.value));
  };

  const handleSetYear = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedYear(parseInt(event.target.value));
  };

  const handleSetMonth = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedMonth(parseInt(event.target.value));
  };

  return (
    <>
      <Modal open={openEntryHourReportModal} size={"sm"} onClose={handleClose}>
        <Modal.Header>
          <Modal.Title>
            <div className="flex items-center gap-2.5">
              <span className="dv-aura flex h-9 w-9 items-center justify-center rounded-xl bg-dv-gradient text-white shadow-dv-glow">
                <MdAssignment className="h-5 w-5" aria-hidden="true" />
              </span>
              <span className="text-lg font-bold text-navy-700 dark:text-white">
                Relatório de Apontamentos
              </span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-4 text-sm text-gray-700 dark:text-gray-300">
            Selecione o período e o cliente para gerar o relatório de horas.
          </p>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div className="flex flex-col gap-1.5">
              <label htmlFor="report-year" className={labelCls}>
                Ano
              </label>
              <select
                className={fieldCls}
                id="report-year"
                onChange={handleSetYear}
                value={selectedYear}
              >
                <option value={2023}>2023</option>
                <option value={2024}>2024</option>
              </select>
            </div>
            <div className="flex flex-col gap-1.5">
              <label htmlFor="report-month" className={labelCls}>
                Mês
              </label>
              <select
                className={fieldCls}
                id="report-month"
                value={selectedMonth}
                onChange={handleSetMonth}
              >
                {MONTH_LABELS.map((m, i) => (
                  <option key={i + 1} value={i + 1}>
                    {m}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-1.5 sm:col-span-2">
              <label htmlFor="report-client" className={labelCls}>
                Cliente <span className="text-red-500">*</span>
              </label>
              <select
                className={fieldCls}
                id="report-client"
                onChange={handleClientChange}
                value={selectedC}
              >
                <option value={0}>Selecione o cliente</option>
                {projectData
                  .filter(
                    (cp, index, self) =>
                      self.findIndex((x) => x.clientId === cp.clientId) === index
                  )
                  .map((cp) => (
                    <option key={cp.clientId} value={cp.clientId}>
                      {cp.nmCorporate}
                    </option>
                  ))}
              </select>
            </div>
            <div className="flex flex-col gap-1.5 sm:col-span-2">
              <label htmlFor="report-project" className={labelCls}>
                Projeto
              </label>
              <select
                className={fieldCls}
                id="report-project"
                onChange={handleProjectChange}
                value={selectedP}
                disabled={selectedC === 0}
              >
                <option value={0}>Selecione o projeto</option>
                {projectData
                  .filter((c) => c.clientId === selectedC)
                  .map((cp) => (
                    <option key={cp.projectId} value={cp.projectId}>
                      {cp.nmProject}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          {errorMessage && (
            <div className="mt-4 rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-sm font-medium text-red-700 dark:border-red-500/30 dark:bg-red-900/20 dark:text-red-300">
              {errorMessage}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="flex flex-col gap-2.5 sm:flex-row sm:justify-end">
            <button
              type="button"
              onClick={handleClose}
              className="flex items-center justify-center gap-1.5 rounded-xl border border-gray-200 px-5 py-2.5 text-sm font-semibold text-gray-700 transition-all hover:bg-gray-50 active:scale-[.98] dark:border-white/15 dark:text-gray-200 dark:hover:bg-white/5"
            >
              Cancelar
            </button>
            <button
              type="button"
              onClick={handleGenerateReport}
              disabled={selectedC === 0 || loading}
              className="flex items-center justify-center gap-1.5 rounded-xl bg-ink-900 px-5 py-2.5 text-sm font-bold text-white shadow-dv-md transition-all hover:bg-ink-800 active:scale-[.98] disabled:cursor-not-allowed disabled:opacity-50 dark:bg-white dark:text-ink-900 dark:hover:bg-gray-100"
            >
              <MdDownload className="h-4 w-4" aria-hidden="true" />
              {loading ? "Processando…" : "Gerar relatório"}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default EntryHourReportModal;
